import { isEncryptedField } from '@/infra/crypto/payloads'
import type { MetadataPayload } from '@/infra/sse/shared/payloads'
import type { DecryptFn, RawEventMetadata } from './types'
import { ENCRYPTED_PLACEHOLDER, tryDecryptString } from './helpers'

export const processRawMetadata = async (
  raw: RawEventMetadata,
  decrypt: DecryptFn | null,
  keyVersion: number | undefined,
): Promise<MetadataPayload> => {
  let transcriptPath: string
  if (decrypt !== null && keyVersion !== undefined && isEncryptedField(raw.transcriptPath)) {
    transcriptPath = await tryDecryptString(
      raw.transcriptPath,
      keyVersion,
      decrypt,
      ENCRYPTED_PLACEHOLDER,
    )
  } else {
    transcriptPath =
      typeof raw.transcriptPath === 'string' ? raw.transcriptPath : ENCRYPTED_PLACEHOLDER
  }

  let contextWorkDirectory: string
  if (decrypt !== null && keyVersion !== undefined && isEncryptedField(raw.contextWorkDirectory)) {
    contextWorkDirectory = await tryDecryptString(
      raw.contextWorkDirectory,
      keyVersion,
      decrypt,
      ENCRYPTED_PLACEHOLDER,
    )
  } else {
    contextWorkDirectory =
      typeof raw.contextWorkDirectory === 'string'
        ? raw.contextWorkDirectory
        : ENCRYPTED_PLACEHOLDER
  }

  return {
    timestamp: raw.timestamp,
    userExternalId: raw.userExternalId,
    claudeSessionId: raw.claudeSessionId,
    userPromptId: raw.userPromptId,
    eventId: raw.eventId,
    hookType: raw.hookType,
    transcriptPath,
    contextWorkDirectory,
    agentMode: raw.agentMode ?? 'UNKNOWN',
    ...(raw.dangerouslySkipPermissions !== undefined && {
      dangerouslySkipPermissions: raw.dangerouslySkipPermissions,
    }),
    ...(raw.autoModeSupported !== undefined && { autoModeSupported: raw.autoModeSupported }),
  }
}
